/** The names in orno's icon set (`Orno.icons`). */
export type IconName =
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-down'
  | 'chevron-up'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-up'
  | 'arrow-down'
  | 'external'
  | 'close'
  | 'check'
  | 'plus'
  | 'minus'
  | 'search'
  | 'filter'
  | 'edit'
  | 'trash'
  | 'copy'
  | 'download'
  | 'upload'
  | 'refresh'
  | 'more'
  | 'menu'
  | 'home'
  | 'wallet'
  | 'chart'
  | 'calendar'
  | 'document'
  | 'folder'
  | 'tag'
  | 'user'
  | 'users'
  | 'settings'
  | 'lock'
  | 'key'
  | 'mail'
  | 'link'
  | 'eye'
  | 'eye-off'
  | 'star'
  | 'clock'
  | 'info'
  | 'warning'
  | 'error'
  | 'success';

/**
 * `<orno-icon>` with its name checked: decoration (hidden from screen readers) unless it has a `label`. The element
 * re-renders when its attributes change, so it needs nothing else.
 */
export function Icon({
  name,
  size = 16,
  label,
}: {
  name: IconName;
  size?: 16 | 18 | 20 | 24;
  label?: string;
}) {
  return <orno-icon name={name} size={size} label={label} />;
}
